// Who this client is, and the one place their record can be deleted.
//
// Four blocks, top to bottom: the terms of business, the people to reach (ContactsCard,
// migration 071), who they are (ProfileCard), and the two acts that end the relationship.
// Deactivating sits beside delete because it is the non-destructive version of the same
// impulse; delete stays down here, away from the page header, and its dialog carries the
// full consequence.
import { useLookups } from '../../context/LookupsContext';
import he from '../../i18n/he';
import Button from '../../components/Button';
import ProfileCard from './ProfileCard';
import ContactsCard from './ContactsCard';

const Row = ({ label, value }) => (
  <>
    <dt>{label}</dt>
    <dd>{value || '—'}</dd>
  </>
);

export default function DetailsTab({
  client, onEdit, onDelete, onToggleActive, onReload,
}) {
  const lookups = useLookups();
  return (
    <>
      <div className="card">
        <div className="client-section-head">
          <h2>{he.clientCard.tabs.details}</h2>
          <Button small variant="ghost" onClick={onEdit}>{he.common.edit}</Button>
        </div>
        <dl className="client-details">
          <Row label={he.clients.method} value={lookups.methodLabel(client.payment_method)} />
          <Row label={he.clients.terms} value={lookups.termLabel(client.payment_terms)} />
          <Row label={he.clients.stage} value={he.leadStages[client.stage] || client.stage} />
          <Row label={he.clients.owner} value={client.owner_name || he.clientCard.noOwner} />
        </dl>
      </div>

      <ContactsCard client={client} onSaved={onReload} />
      <ProfileCard client={client} onSaved={onReload} />

      {/* Only a view state: nothing is deleted, and no figure anywhere reads the flag. */}
      <div className="client-end-actions">
        <Button small variant="subtle" onClick={() => onToggleActive(!client.is_active)}>
          {client.is_active ? he.clientCard.deactivate : he.clientCard.activate}
        </Button>
        <Button small variant="danger" onClick={onDelete}>{he.clientCard.deleteClient}</Button>
      </div>
    </>
  );
}
